<div class="page">
  @if (mission) {
    <app-section-toolbar
      [sectionTitle]="'MISSION.PRODUCT' | translate"
      [isComplete]="isProductComplete()"
      [addLabel]="'UI.ADD.CONTAINER' | translate"
      (back)="backToMissionConfig()"
      (toggleStatus)="toggleProductStatus()"
      (add)="openContainerModal()">
    </app-section-toolbar>

    <div class="products">
      @for (missionProduct of mission.products; track missionProduct) {
        @let loaded = getLoadedQuantity(missionProduct);
        @let ordered = missionProduct.productmissionLoadedExpectedMassTotal;
        <section class="card product">
          <div class="product__header">
            <div class="product__name">
              <ng-icon name="heroBeaker" size="18"/>
              {{ missionProduct.productName }}
            </div>
            @if (!isProductComplete()) {
              <button type="button" class="icon-action" [title]="'EDIT' | translate" (click)="updateMissionProduct(missionProduct)">
                <ng-icon name="heroPencilSquare" size="18"/>
              </button>
            }
          </div>
          <div class="product__figures">
            <div>
              <div class="figure__label">{{ 'PRODUCT.LOADED_QUANTITY' | translate }}</div>
              <div class="figure__value" [class.reached]="loaded >= ordered">{{ loaded | number : '1.0-0' }} <small>{{ mission.weightUom }}</small></div>
            </div>
            <div class="figure--end">
              <div class="figure__label">{{ 'MISSIONS.ORDERED_QUANTITY' | translate }}</div>
              <div class="figure__value">{{ ordered | number : '1.0-0' }} <small>{{ mission.weightUom }}</small></div>
            </div>
          </div>
          <div class="progress" [class.reached]="loaded >= ordered">
            <span [style.width.%]="ordered > 0 ? (loaded / ordered * 100 > 100 ? 100 : loaded / ordered * 100) : 0"></span>
          </div>
        </section>
      }
    </div>
  }

  <section class="card">
    <div class="card__header">
      <div class="card__title">
        <ng-icon name="heroTruck" size="20"/>
        {{ 'PRODUCT.CONTAINER' | translate }}s
        <span class="count-badge">{{ containers.length }}</span>
      </div>
    </div>
    @if (containers.length) {
      <table class="data-table">
        <thead>
          <tr>
            <th>{{ 'PRODUCT.CONTAINER' | translate }}</th>
            <th>{{ 'PRODUCT.QUANTITY' | translate }} ({{ mission.weightUom }})</th>
            <th>{{ 'PRODUCT.LOADING_STATION' | translate }}</th>
            <th>{{ 'PRODUCT.LABEL' | translate }}</th>
            <th>{{ 'CONTAINER.TRANSPORT_COMPANY' | translate }}</th>
            <th>{{ 'PRODUCT.LAST_UPDATE' | translate }}</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          @for (container of containers; track container; let i = $index) {
            <tr [class.in-error]="container.isInError">
              <td class="cell-strong">
                <span class="container-id">
                  {{ container.containerId }}
                  @if (container.isInError) {
                    <span class="warning" [title]="'PRODUCT.CONTAINER_IN_WARNING' | translate | containerWarning: container">
                      <ng-icon name="heroExclamationTriangle" size="16"/>
                    </span>
                  }
                </span>
              </td>
              <td class="cell-input">
                <df-number-input #quantityInput size="small"
                  [status]="container.isInError ? 'error' : 'default'"
                  [value]="container.loadedQty"
                  (blurred)="setContainerQuantity(quantityInput.value(), container)"
                  (keydown.enter)="setContainerQuantity(quantityInput.value(), container)"
                  [disabled]="isProductComplete()" />
              </td>
              <td class="cell-input">
                <df-select size="small" ariaLabel="Loading station" [clearable]="false"
                  [options]="loadingStations | selectOptions:'name'"
                  [value]="container.loadingstationName"
                  (selectionChange)="setContainerLoadingStation($event, container)"
                  [disabled]="isProductComplete()" />
              </td>
              <td class="cell-input">
                <df-select size="small" ariaLabel="Product" [searchable]="false" [clearable]="false"
                  [options]="mission.products | selectOptions:'productName'"
                  [value]="container.productName"
                  (selectionChange)="setContainerProduct($event, container)"
                  [disabled]="isProductComplete()" />
              </td>
              <td>{{ container.transportcompanyName }}</td>
              <td class="cell-muted">{{ container.lastUpdatedOn | timestampToDate | async }} · {{ container.lastUpdatedBy }}</td>
              <td class="cell-actions">
                @if (!isProductComplete()) {
                  <button type="button" class="icon-action danger" [title]="'DELETE' | translate" (click)="removeMissionContainer(container)">
                    <ng-icon name="heroTrash" size="18"/>
                  </button>
                }
              </td>
            </tr>
          }
        </tbody>
      </table>
    } @else {
      <div class="empty-state">
        <ng-icon name="heroTruck" size="32"/>
        <div class="empty-state__title">{{ 'UI.EMPTY.CONTAINERS' | translate }}</div>
        <div class="empty-state__text">{{ 'UI.EMPTY.CONTAINERS_MISSION' | translate }}</div>
      </div>
    }
  </section>
</div>

@if (addingContainer) {
  <app-add-container [mission]="mission" [missionContainers]="containers" (closeModal)="closeContainerModal($event)"></app-add-container>
}
@if (updateMissionProductParams.display) {
  <app-update-mission-product [params]="updateMissionProductParams"></app-update-mission-product>
}
